import { Component, OnInit } from '@angular/core';
import { NbToastrService } from '@nebular/theme';
import { ApiService } from '../../@core/service/api.service';
import * as moment from 'moment';
import { DebugModel, EDebugType } from '../../@models/debug';
import { IDropdownOptions, SharedDataService } from '../../@core/service/shared-data.service';
import { mongoId } from '../../@core/common/global';
import { UserModel } from '../../@models';

@Component({
  selector: 'dev-helper',
  templateUrl: './dev-helper.component.html',
  styleUrls: ['./dev-helper.component.scss']
})
export class DevHelperComponent implements OnInit {

  protected fromDate: Date | string;
  protected toDate: Date | string;

  protected debugData: DebugModel[] = [];
  protected filteredDebugData: DebugModel[] = [];
  private stringifiedData = [];

  protected showmongohelper = false;
  protected showdebuglog = false;

  search = {} as any;

  debugType = EDebugType;
  debugTypeOptions = [{ id: '', name: '' }, ...Object.keys(EDebugType).map(m => ({ id: m, name: EDebugType[m] }))];
  userOptions: IDropdownOptions[];

  constructor(protected api: ApiService, private toastr: NbToastrService, protected data: SharedDataService) { }

  async ngOnInit() {

    await this.data.loadUsers();
    this.userOptions = [{ id: '', name: ''}, ...this.data.userOptions];

    this.fromDate = moment().subtract(7, 'days').toDate();
    this.toDate = new Date();
    this.loadDebug();
  }

  async runQueryRunner() {
    await this.api.queryRunner();
    this.toastr.info('query runner finished', 'Task');
  }

  getUser(user: UserModel) {
    return this.data.users?.find(f => mongoId(f) === user)?.short;
  }

  async loadDebug() {

    const filter = {
      date: {
        $gte: `${new Date(this.fromDate).toISOString()}`,
        $lte: `${new Date(this.toDate).toISOString()}`,
      }
    }

    this.debugData = await this.api.getDebug(filter);
    this.stringifiedData = this.debugData.map(m => JSON.stringify(m.data));

    console.log('got debug', filter, this.fromDate, this.toDate, this.debugData);
    this.setFilteredDebugData();

  }

  joinArray(data: string[]) {
    return data.join('<br>');
  }

  getLogData(data: object) {
    const res = JSON.stringify(data, null, 2);
    const arr = res?.split('\n');
    const short = arr?.length > 10 ? arr?.slice(0, 10).join('\n') + "\n ..." : null;
    return { res, short };
  }

  setFilteredDebugData() {
    console.log('setFilteredDebugData', this.search);
    this.filteredDebugData = [...this.debugData].filter((f, idx) => 
      (!this.search.user || f.user === this.search.user)
      && (!this.search.type || +f.type === +this.search.type)
      && (!this.search.subject || f.subject?.includes(this.search.subject))
      && (!this.search.data || this.stringifiedData[idx]?.includes(this.search.data))
    );
  }

  sanitizeField() {
    this.api.sanitizeField(null);
  }

  fiscalYearUpdate() {
    this.api.fiscalYearUpdate(null);
  }

}
